module.exports = __webpack_public_path__ + "img/case-bayer.1327b82e.png";